import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const CREATE_ORG_APP_SUBSCRIPTION_RESOURCE = 'createOrgAppSubscription';

const createOrgAppSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_ORG_APP_SUBSCRIPTION_RESOURCE,
      method: 'post',
      request: (body, callback, rejectCallback, t) => ({
        url: apiRoutes.organisationApps(),
        body,
        meta: {
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'addSubscriptionFailed'),
            onSuccessMessage: t('addSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default createOrgAppSubscriptionService;
